import { Injectable } from '@angular/core';
import { interval, Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

/**
 * Shared time update service that provides a single 60-second interval
 * for all components that need periodic time updates.
 */
@Injectable({
  providedIn: 'root',
})
export class SharedTimeUpdateService {
  private readonly timeUpdate$: Observable<number>;

  constructor() {
    this.timeUpdate$ = interval(60000).pipe(
      map(() => Date.now()),
      shareReplay(1),
    );
  }

  get timeUpdates$(): Observable<number> {
    return this.timeUpdate$;
  }

  getCurrentTime(): number {
    return Date.now();
  }
}
